// extracted by mini-css-extract-plugin
export default {"section":"Section_section__06lK0","inner":"Section_inner__Sb7pR","head":"Section_head__YiHg+","eyebrow":"Section_eyebrow__4GXib","title":"Section_title__kR3xc"};